import styled, { keyframes } from 'styled-components';

import { SkeletonProps } from './Skeleton';

// `keyframes`, not a nested `@keyframes`: nested names stay global in styled-components v5.
const shimmerSlide = keyframes`
  0% {
    transform: translateX(-150%);
  }

  50% {
    transform: translateX(-60%);
  }

  100% {
    transform: translateX(150%);
  }
`;

export const SkeletonWrapper = styled.div<SkeletonProps>`
  width: ${({ width }) => (width ? `${width}px` : '100%')};
  height: ${({ height }) => height}px;
  border-radius: ${({ borderRadius }) => borderRadius}px;
  margin-bottom: ${({ marginBottom }) => marginBottom}px;
  margin-left: ${({ marginLeft }) => marginLeft}px;
  margin-right: ${({ marginRight }) => marginRight}px;
  position: relative;
  overflow: hidden;
  background-image: linear-gradient(140deg, #e3e7eb 1%, #eef1f4 52%, #e3e7eb);
`;

export const ShimmerWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  animation: ${shimmerSlide} 1.5s infinite;
  will-change: transform;
`;
export const Shimmer = styled.div`
  width: 55%;
  height: 100%;
  background: linear-gradient(
    90deg,
    rgba(255, 255, 255, 0) 0%,
    rgba(255, 255, 255, 0.35) 30%,
    rgba(255, 255, 255, 0.9) 50%,
    rgba(255, 255, 255, 0.35) 70%,
    rgba(255, 255, 255, 0) 100%
  );
  transform: skewX(-20deg);
`;
